import { useEffect, useRef, useState } from 'react';
import { path } from 'ramda';
import { useMutation } from '@apollo/client';

import { reserveMailinTicketRequest } from './gql';

const useMailinTicketRequestReservation = (sweepstakesId) => {
  const [reservation, setReservation] = useState(null);
  const [error, setError] = useState(null);
  const retryRef = useRef(null);
  const hasFetchedRef = useRef(false);

  const [reserve] = useMutation(reserveMailinTicketRequest, {
    variables: { sweepstakesId },
  });

  useEffect(() => {
    const fetchReservation = (attempt = 0) => {
      const scheduleRetry = () => {
        if (attempt > 2) {
          setError("Failed to set up mail-in ticket request after multiple attempts. To continue you must reload the page");
          return;
        }

        const delay = 100 * Math.pow(2, attempt + 1);
        retryRef.current = setTimeout(() => fetchReservation(attempt + 1), delay);
      };

      reserve()
        .then(({ data }) => {
          const reservationData = data?.reserveMailinTicketRequest;
          if (reservationData?.error) {
            if (reservationData.error.code === "limited") {
              setError(reservationData.error.message);
              return;
            }
            scheduleRetry();
            return;
          }
          setReservation(path(["mailinTicketRequestReservation", "id"], reservationData));
        }).catch(scheduleRetry);
    };

    if (!hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchReservation();
    }

    return () => clearTimeout(retryRef.current);
  }, [reserve]);

  return { reservation, error };
};

export default useMailinTicketRequestReservation;
